import {CalendarioChiusureRecord} from "@commons/mapping/CalendarioChiusureRecord";
import {FPNetDate, IndiceMese, Periodo} from "@commons/types";
import {DateTime, Interval} from "luxon";

export const _isMonitorWFEditabile = function (isEmployee: boolean, calendario: CalendarioChiusureRecord | undefined | null, startDate: Date | null, endDate: Date | null, rifDate?: Date) {
    const getMeseRiferimento = function (startDate: Date, endDate: Date): IndiceMese | null {
        const monthStartDate = DateTime.fromJSDate(startDate).month;
        const monthEndDate = DateTime.fromJSDate(endDate).month;
        if (monthStartDate === monthEndDate) {
            return monthStartDate as IndiceMese;
        }
        return null;
    };

    let editabile = false;
    if (isEmployee) {
        if (calendario) {
            if (calendario.enabled) {
                if (calendario.anno && !!startDate && !!endDate) {
                    const yearStartDate = DateTime.fromJSDate(startDate).year;
                    const yearEndDate = DateTime.fromJSDate(endDate).year;
                    if (yearStartDate === yearEndDate) {
                        const meseRif = rifDate ? DateTime.fromJSDate(rifDate).month as IndiceMese : getMeseRiferimento(startDate, endDate);
                        const data = meseRif ? CalendarioChiusureRecord.getScadenza(calendario, meseRif) : null;
                        if (data !== null) {
                            editabile = (DateTime.now() <= data.endOf('day'));
                        }
                        // N.B. Altrimenti NON è editabile!
                    }
                    // N.B. Altrimenti NON è editabile!
                } else {
                    // Non valutabile, il periodo in esame riguarda più anni o estremi non forniti
                    // N.B. Altrimenti NON è editabile!
                }
            } else {
                editabile = true; // Calendario disabilitato
            }
        } else {
            // Calendario non istanziato
            editabile = true;
        }
    } else {
        editabile = true; // Se utente NON employee SEMPRE editabile
    }
    return editabile;
};

/**
 * Verifica se per il giorno indicato le richieste di WF o le "presenze" sono modificabili!
 * N.B. da usare in and con:
 * const isPeriodoChiuso = GestionePlus.statoPeriodo(aziendaCorrente, periodo, lavoratore?.days || null, null, user).chiuso
 */
export const isEditabile = function (isEmployee: boolean, calendario: CalendarioChiusureRecord | undefined | null, currentDay: FPNetDate, periodo: Periodo) {
    const startDate = Periodo.getDate(periodo);
    const endDate = Periodo.getDate(periodo);
    const rifDate = currentDay ? DateTime.fromISO(currentDay) : null;

    // N.B. Luxon intervals are half-open, so like inclusivity=[). There is currently no way to change that, besides adding a millisecond to the end
    if (rifDate && Interval.fromDateTimes(startDate, endDate.plus({'millisecond': 1})).contains(rifDate)) {
        // Se ho selezionato un giorno del mese allora valuto editing
        if (calendario && calendario.enabled) {
            // Valuto calendario
            return _isMonitorWFEditabile(isEmployee, calendario, startDate.toJSDate(), endDate.toJSDate());
        }
        return true;
    }

    // Sulle giornate relative ad altri mesi rispetto a <periodo> l'editing è sempre negato!
    return false;
};

export const isPeriodoEditabile = function (isEmployee: boolean, calendarioChiusure: CalendarioChiusureRecord | undefined | null, periodo: Periodo) {
    return isEditabile(isEmployee, calendarioChiusure, Periodo.getDate(periodo).toISO(), periodo);
}
